import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

// capital-mui-theme v37 gray50 token. Token not available in v36
const muiV37Gray50 = '#F8F8F8';
const blurple100 = '#EEF1FC';

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '24px',
    backgroundColor: muiV37Gray50
  },
  dialogContent: {
    minHeight: '500px'
  },
  dialogContentBox: {
    padding: '24px 70px'
  },
  reportTypeSelector: {
    display: 'flex',
    gap: '16px',
    marginBottom: '32px'
  },
  reportTypeCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    height: '87px',
    backgroundColor: capitalDesignTokens.foundations.colors.white,
    border: `1px solid ${capitalDesignTokens.foundations.colors.gray300}`,
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: capitalDesignTokens.semanticColors.interaction.focus,
      boxShadow: `0 2px 4px ${capitalDesignTokens.foundations.colors.gray300}`
    }
  },
  reportTypeCardSelected: {
    backgroundColor: blurple100,
    borderColor: capitalDesignTokens.foundations.colors.gray300
  },
  reportTypeCardDisabled: {
    cursor: 'not-allowed',
    opacity: 0.6,
    pointerEvents: 'none',
    '&:hover': {
      borderColor: capitalDesignTokens.foundations.colors.gray300,
      boxShadow: 'none'
    }
  },
  reportTypeIcon: {
    fontSize: '32px',
    color: capitalDesignTokens.foundations.colors.gray800
  },
  reportTypeLabel: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
    color: capitalDesignTokens.foundations.colors.gray800
  },
  reportTypeCardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px'
  },
  closeIconButton: {
    padding: 0
  },
  configurationArea: {
    marginTop: '24px'
  },
  dialogActions: {
    padding: '24px',
    backgroundColor: muiV37Gray50
  },
  actionButton: {
    width: '80px'
  },
  loadingIcon: {
    color: capitalDesignTokens.foundations.colors.white,
    marginLeft: '8px'
  }
});
